// extracted by extract-css-chunks-webpack-plugin
module.exports = {"zoho":"css-3uApKiGzyX"};